<template>
  <div>
    <a href="javascript:;" @click="sendMsg">send</a>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    methods: {
      sendMsg() {
        console.log('this.sendMsg')
        window.parent.postMessage('success', '*')
      },
    },
  }
</script>
